export enum InteractionType {
  None = 'None',
  GameInteraction = 'GameInteraction',
  RewardInteraction = 'RewardInteraction',
}
